import Layout from '../../components/layout/Layout'
import OrdersByTypeTable from '../../elements/tables/orders/OrderByTypeTable'

export default function OrderByType() {
  return (
    <div>
      <Layout>
        <OrdersByTypeTable />
      </Layout>
    </div>
  )
}
